import React, { use, useEffect, useState } from "react";
import {
  Users,
  Book,
  Settings,
  User,
  LogOut,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
} from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./DashboardLeftSection.css";
import SessionsList from "../dashboardLeftSectionComponent/SessionList";
import useUserStore from "../../store/useUserStore";
import { useMsal } from "@azure/msal-react";
import SurgicalList from "../dashboardLeftSectionComponent/SurgicalList";

export default function DashboardLeftSection({
  createNewSession,
  setIsSelectedPatient,
}) {
  const { user, logout,setIsMobile,isMobile,activePage,setActivePage,isRecordingStarted } = useUserStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showLogout, setShowLogout] = useState(false);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, [user]);

  const handleCreateSession = () => {
    if(isRecordingStarted){
      alert("Recording is continued. Please, stop the recording")
    }
    createNewSession();
    navigate("/dashboard")
  };

  const handleLogout = async () => {
    const currentAccount = instance.getAccountByHomeId(
      accounts[0]?.homeAccountId
    );
    logout();
    await instance.clearCache();
    window.location.href = "/"
    // // await instance.logoutRedirect({ account: currentAccount });
    // instance.logoutPopup({
    //   postLogoutRedirectUri: "http://localhost:3000"
    // });
    // await instance.logout()
  };

  return (
    <div
      className={`dashboard-container 
        ${isSidebarVisible ? "sidebar-visible" : "sidebar-hidden"}
        ${isMobile? (activePage==="sidebar"?"sidebar-visible": "sidebar-hidden-mobile"):" "}
      `}
    >
      {/* Toggle Button */}
      {!isSidebarVisible && (
        <button
          className="toggle-sidebar-btn"
          onClick={() => setIsSidebarVisible(!isSidebarVisible)}
        >
          <ChevronRight />
        </button>
      )}

      {isSidebarVisible && (
        <div className="left-section">
          {/* Company Header */}
          <div className="company-header">
            <div className="company-wrapper">
              <div className="company-logo">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
              </div>
              <span className="company-name">Company</span>
            </div>
            {isSidebarVisible && (
              <button
                className="close-sidebar"
                onClick={() => setIsSidebarVisible(!isSidebarVisible)}
              >
                <ChevronLeft />
              </button>
            )}
          </div>

          {/* Start Session Button */}
          <div className="start-session-container">
            <button className="start-session-btn" disabled={isRecordingStarted} onClick={handleCreateSession}>
              <span>+</span>
              Start session
            </button>
          </div>

          {/* <SessionsList setIsSelectedPatient={setIsSelectedPatient} /> */}
          <SessionsList />
          <SurgicalList />

          {/* Navigation Menu */}
          <nav className="nav-menu">
            <Link to="/dashboard/dictionary" disabled={isRecordingStarted} onClick={()=>setActivePage("dictionary")} className="nav-item">
              <Book className="nav-icon" />
              <span>Medical dictionary</span>
            </Link>
            {/* <Link to="/dashboard/preferences" disabled={isRecordingStarted} className="nav-item">
              <Settings className="nav-icon" />
              <span>Session preferences</span>
            </Link> */}
          </nav>

          {/* Profile Section */}
          <div
            className="profile-section"
            onMouseEnter={() => setShowLogout(true)}
            onMouseLeave={() => setShowLogout(false)}
          >
            <button className="profile-button" >
              <div className="profile-name-wrapper">
                <div className="profile-avatar">
                  {user?.first_name.charAt(0) + user?.last_name.charAt(0)}
                </div>
                <div>{user?.first_name + " " + user?.last_name}</div>
              </div>
              <ChevronUp />
            </button>

            <div
              className="profile-select-container"
              style={{ display: !showLogout ? "none" : "" }}
            >
              <button className="logout-button" onClick={handleLogout}>
                <LogOut className="logout" />
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
